module.exports = __webpack_public_path__ + "static/media/raven_sad_08.0d5e163f.svg";